// Namensraum "company": Firmeneinstellungen
const company = {
  'nav.adminCompany': 'Firmeneinstellungen',
  'admin.overview.company.title': 'Firmeneinstellungen',
  'admin.overview.company.desc': 'Freizeitausgleichstage für das Unternehmen festlegen',
  'company.title': 'Firmeneinstellungen',
  'company.compTime.section': 'Freizeitausgleichstage (FZT)',
  'company.compTime.enabled': 'Freizeitausgleichstage aktivieren',
  'company.compTime.enabledHint': 'Ohne Aktivierung gibt es im Unternehmen keine Freizeitausgleichstage.',
  'company.compTime.maxDays': 'Maximale FZT pro Benutzer und Kalenderjahr',
  'company.save': 'Speichern',
  'company.saved': 'Einstellungen gespeichert.',
  'company.error.negative': 'Der Maximalwert darf nicht negativ sein.',
  'company.error.load': 'Einstellungen konnten nicht geladen werden.',
  'company.error.save': 'Speichern fehlgeschlagen.',
};

export default company;
